import { Card, Tag } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  toUrl: string
  name: string
  isNew: boolean
  description: string
  toLabel: string
  onClick: (() => void) | undefined
}

export const Item = ({ isNew, toUrl, name, description, toLabel, onClick }: Props) => {
  const status = isNew
    ? {
        label: i18n.t('marketplace.modules.new'),
        color: 'lime',
      }
    : undefined

  return (
    <Card to={toUrl} onClick={onClick}>
      {status && (
        <Card.Eyebrow>
          <Tag type="lime">{status.label}</Tag>
        </Card.Eyebrow>
      )}

      <Card.Title>{name}</Card.Title>
      <Card.Description>{description}</Card.Description>
      <Card.Link to={toUrl}>{toLabel}</Card.Link>
    </Card>
  )
}
